import { Fragment } from "react";
import { DashboardMyCredit } from "../../../../components/backgrounds/DashboardMyCredit";
import { SkeletonDahsboard } from "../../../../components/skeleton/skeletonDash";


export function SkeletonMethodsPage() {
    return (
        <Fragment>
            <DashboardMyCredit
                name={"Cargando"}
                balance={""}
                current={"2"}
                title={"Medio de pago"}
                main={
                    <>
                        <div className="relative py-10 px-6 lg:px-0 grid grid-cols-8 gap-4">
                            <div className="col-span-8 xl:col-span-4 grid content-between h-full rounded-2xl transition py-4 bg-white">
                                <div className="flex justify-between pb-6">
                                    <div className="flex gap-2 text-lg font-bold mx-auto pt-2">
                                        <div>
                                            <SkeletonDahsboard
                                                variant={"circular"}
                                                height={30}
                                                width={30}
                                            />
                                        </div>
                                        <h3 className="">
                                            <SkeletonDahsboard height={30} width={130} />
                                        </h3>
                                    </div>
                                </div>
                                <div className="px-4 pt-6">
                                    <div>
                                        <div className="flex pb-4 gap-2">
                                            <SkeletonDahsboard
                                                variant={"circular"}
                                                height={15}
                                                width={15}
                                            />
                                            <div className="">
                                                <SkeletonDahsboard height={20} width={230} />
                                            </div>
                                        </div>
                                        <div className="flex pb-4 gap-2">
                                            <SkeletonDahsboard
                                                variant={"circular"}
                                                height={15}
                                                width={15}
                                            />
                                            <div className="">
                                                <SkeletonDahsboard height={20} width={230} />
                                            </div>
                                        </div>
                                        <div className="flex pb-4 gap-2">
                                            <SkeletonDahsboard
                                                variant={"circular"}
                                                height={15}
                                                width={15}
                                            />
                                            <div className="">
                                                <SkeletonDahsboard height={20} width={230} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex pr-4 justify-end">
                                    <SkeletonDahsboard height={20} width={60} />
                                </div>
                            </div>
                            <div className="col-span-8 xl:col-span-4 grid content-between h-full rounded-2xl transition py-4 bg-white">
                                <div className="flex justify-between pb-6">
                                    <div className="flex gap-2 text-lg font-bold mx-auto pt-2">
                                        <div>
                                            <SkeletonDahsboard
                                                variant={"circular"}
                                                height={30}
                                                width={30}
                                            />
                                        </div>
                                        <h3 className="">
                                            <SkeletonDahsboard height={30} width={130} />
                                        </h3>
                                    </div>
                                </div>
                                <div className="px-4 pt-6">
                                    <div>
                                        <div className="flex pb-4 gap-2">
                                            <SkeletonDahsboard
                                                variant={"circular"}
                                                height={15}
                                                width={15}
                                            />
                                            <div className="">
                                                <SkeletonDahsboard height={20} width={230} />
                                            </div>
                                        </div>
                                        <div className="flex pb-4 gap-2">
                                            <SkeletonDahsboard
                                                variant={"circular"}
                                                height={15}
                                                width={15}
                                            />
                                            <div className="">
                                                <SkeletonDahsboard height={20} width={230} />
                                            </div>
                                        </div>
                                        <div className="flex pb-4 gap-2">
                                            <SkeletonDahsboard
                                                variant={"circular"}
                                                height={15}
                                                width={15}
                                            />
                                            <div className="">
                                                <SkeletonDahsboard height={20} width={230} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex pr-4 justify-end">
                                    <SkeletonDahsboard height={20} width={60} />
                                </div>
                            </div>
                        </div>
                    </>
                }
            />
        </Fragment>
    )

}